export default class ApiError extends Error {
  constructor(message, {
    status = 0,
    params = {},
    fieldErrors = [],
    kind = 'unknown',
    retryAfter = null,
    cause = null,
  } = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.params = params;
    this.fieldErrors = fieldErrors;
    this.kind = kind;
    this.retryAfter = retryAfter;
    this.cause = cause;
  }

  get isNetworkError() { return this.status === 0; }
  get isUnauthorized() { return this.status === 401; }
  get isForbidden() { return this.status === 403; }
  get isNotFound() { return this.status === 404; }
  get isConflict() { return this.status === 409; }
  get isValidationError() {
    return this.fieldErrors.length > 0 || this.status === 422;
  }
  get isServiceUnavailable() {
    return this.status === 502 || this.status === 503 || this.status === 504;
  }
  get isServerError() { return this.status >= 500; }
}
